import styled from "styled-components";

export const MoreDropdownMenu = styled.div`
  position: absolute;
  right: 0px;
  z-index: 9999999999999999;
  display: ${(props) => props.display ?? "none"};
  float: right;
  min-width: 70px;
  padding: 5px 0;
  margin: 2px 0 0;
  font-size: 14px;
  text-align: left;
  list-style: none;
  background-color: #fff;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
`;
